export default __webpack_public_path__ + "static/media/aboutimg.006ad280.png";